var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0C13.44 0 0 13.44 0 30c0 16.56 13.44 30 30 30 16.56 0 30-13.44 30-30C60 13.44 46.56 0 30 0zm-6 45L9 30l4.23-4.23L24 36.51l22.77-22.77L51 18 24 45z",
    fill: "#466385"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjAgNjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0zMCAwQzEzLjQ0IDAgMCAxMy40NCAwIDMwQzAgNDYuNTYgMTMuNDQgNjAgMzAgNjBDNDYuNTYgNjAgNjAgNDYuNTYgNjAgMzBDNjAgMTMuNDQgNDYuNTYgMCAzMCAwWk0yNCA0NUw5IDMwTDEzLjIzIDI1Ljc3TDI0IDM2LjUxTDQ2Ljc3IDEzLjc0TDUxIDE4TDI0IDQ1WiIgZmlsbD0iIzQ2NjM4NSIvPgo8L3N2Zz4K";
export { SvgCheck as ReactComponent };